import router from "./router";

import store from "./store";
import lang from "./lang";
import { findNavPathDetailed } from "@/utils/recursion";
import { navigation } from "@/components/Navigation/data-zn2";
import { dialogName } from "@/utils/recursion";
import { message1 } from "@/utils/resetMessage";

//当路由开始跳转时
router.beforeEach((to, from, next) => {
  if (!store.state.userPower) {
    store.commit(
      "changeUserPower",
      JSON.parse(localStorage.getItem("userPower")),
    );
  }
  let index = -1;
  if (store.state.userPower) {
    index = store.state.userPower.findIndex((item) => {
      if (item.Name === "站内信") {
        console.log("11111111111111111", item.Name, to.meta.title);
      }
      return item.Name === to.meta.title;
    });
  }

  console.log("111", to, to.fullPath);
  if (lang.locale === "en") {
    const breadcrumblist = findNavPathDetailed(to.fullPath, navigation);
    if (breadcrumblist && breadcrumblist.length !== 0) {
      document.title =
        "Saudi Integrated Management System | " +
        breadcrumblist[breadcrumblist.length - 1].eName;
    } else {
      document.title = "Saudi Integrated Management System";
    }
  } else {
    document.title = "沙特综合管理系统 | " + to.meta.title;
  }

  //判断是否要到密码登录页
  if (localStorage.getItem("userInfo")) {
    let userData = JSON.parse(localStorage.getItem("userInfo"));
    if (userData.PasswordExpired) {
      if (to.meta.title === "修改密码" || to.meta.title === "登录") {
      } else {
        console.log("触发");
        if (lang.locale === "en") {
          message1.warning("Please change your password first!");
        } else {
          message1.warning("请先修改密码!");
        }
        router.push("/module/setPassword");
      }
    }
  }
  if (index !== -1) {
    sessionStorage.setItem("lastRoute", to.fullPath); // 导航时保存路由信息
    dialogName();

    next();
  } else {
    switch (to.name) {
      case "signin":
      case "print":
      case "print2":
      case "newNavigation":
      case "exportExcel":
      case "viewPDF":
      case "leave":
      case "overtime":
      case "ordinary":
      case "examine6":
      case "systemMessage":
      case "permissions":
      case "boxOneBasicInfo":
      case "boxOneLabor":
      case "boxOneSeciality":
      case "boxOneBank":
      case "boxOneSalary":
      case "boxTwoFreign":
      case "evacuate":
      case "ticketRequisition":
      case "ticketChange":
      case "payslip":
      case "bonus":
      case "domesticPayments":
      case "taxClearAll":
      case "incomeCertificate":
      case "positionAdjustmentApplicantion":
      case "feedbacks":
      case "proofEmployment":
      case "employmentSeparation":
      case "personalIncomeTax":
      case "examine1":
      case "examine2":
      case "examine3":
      case "examine4":
      case "consult":
      case "passport":
      case "IQAMA":
      case "visa":
      case "setPassword":
        sessionStorage.setItem("lastRoute", to.fullPath); // 导航时保存路由信息
        dialogName();
        next();
        break;
      case "home":
        let userInfo = null;
        if (localStorage.getItem("userInfo")) {
          userInfo = JSON.parse(localStorage.getItem("userInfo"));
        }
        if (userInfo && !userInfo.IsAdmin) {
          sessionStorage.setItem("lastRoute", "/ordinary/home"); // 导航时保存路由信息
          next("/ordinary/home");
        } else {
          sessionStorage.setItem("lastRoute", to.fullPath); // 导航时保存路由信息
          dialogName();
          next();
        }
        break;
      default:
        if (localStorage.getItem("userInfo")) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          if (!userInfo.IsAdmin) {
            location.href = process.env.VUE_APP_SERVER + "ordinary/permissions";
          } else {
            location.href = process.env.VUE_APP_SERVER + "NoPermissions.aspx";
          }
        } else {
          location.href = process.env.VUE_APP_SERVER + "NoPermissions.aspx";
        }
        // next();
        break;
    }
  }
});
